interface VehicleMetadata {
  vin?: string | null;
  vehicleYear?: string | number | null;
  vehicleMake?: string | null;
  vehicleModel?: string | null;
}
interface RecordingMetadata extends VehicleMetadata { sessionKey: string }

export function reportVehicleHeading(input: {
  vin: string;
  activeSessionKey: string;
  session?: RecordingMetadata;
  summary?: RecordingMetadata;
  vehicle?: VehicleMetadata;
  sessionLoading: boolean;
  vehicleLoading: boolean;
  hasReport: boolean;
}): string {
  const selected = (row?: RecordingMetadata) => row && input.activeSessionKey &&
    row.sessionKey.toLowerCase() === input.activeSessionKey.toLowerCase() ? row : undefined;
  const session = selected(input.session);
  const summary = selected(input.summary);
  const text = (value: unknown) => value == null ? '' : String(value).trim();
  const vin = (value: unknown) => {
    const candidate = text(value);
    return /^(?:NO[ _-]?VIN|UNKNOWN)$/i.test(candidate) ? '' : candidate;
  };
  const recordingVin = vin(session?.vin) || vin(summary?.vin);
  const vehicleVin = vin(input.vehicle?.vin) || vin(input.vin);
  // A URL lookup for another VIN must not label this selected recording.
  const vehicle = recordingVin && vehicleVin && recordingVin.toUpperCase() !== vehicleVin.toUpperCase()
    ? undefined : input.vehicle;
  for (const metadata of [session, summary, vehicle]) {
    const parts = [metadata?.vehicleYear, metadata?.vehicleMake, metadata?.vehicleModel].map(text).filter(Boolean);
    if (parts.length) return parts.join(' ');
  }
  if (!input.hasReport && ((!!input.activeSessionKey && input.sessionLoading) || (!!input.vin && input.vehicleLoading)))
    return 'Loading vehicle details…';
  const knownVin = recordingVin || vehicleVin;
  return knownVin ? `VIN ${knownVin}` : 'Vehicle details unavailable';
}
